import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, HideScrollbar } from '../../global/commonStyle';

interface Props {
  isTaskList?: boolean;
}

const Container = styled.div<Props>`
  ${FlexBetween}
  padding: var(--space-10) var(--space-14);
  background-color: var(--background-secondary);
  border-bottom: 0.5px solid var(--border-primary);
  ${mobile_xl(css`
    align-items: flex-start;
    flex-direction: column;
    padding: var(--space-0) var(--space-20);
    border-bottom: none;
    height: auto;
    position: relative;
    z-index: var(--z-index-999);
    .web {
      display: none;
    }
  `)}
`;
const MainContent = styled.div`
  position: sticky;
  top: 0;
  z-index: var(--z-index-999);
  width: 100%;
  ${mobile_xl(css`
    all: unset;
  `)}
`;
const Content = styled.div`
  ${AlignCenter}
  gap: var(--space-20);
  ${mobile_xl(css`
    width: 100%;
    padding: var(--space-8) var(--space-20);
    margin-inline: -20px;
    ${HideScrollbar}
  `)}
`;

const Title = styled.h1`
  ${Typography.heading_md}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const ButtonBlock = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  cursor: pointer;
  position: relative;
  ${mobile_xl(css`
    gap: var(--space-6);
  `)}
`;

const Options = styled.div`
  width: 100%;
  ${AlignCenter}
  background-color: var(--background-tertiary);
  border-radius: var(--border-radius-12);
  padding: var(--space-4);
  ${mobile_xl(css`
    height: 26px;
    padding: var(--space-3);
  `)}
`;

const DropText = styled.p`
  ${Typography.body_md}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const TextBlock = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  padding: var(--space-4) var(--space-16) var(--space-4) var(--space-12);
  ${mobile_xl(css`
    margin-left: var(--space-10);
  `)}
`;

const PrimaryButton = styled.a`
  padding: var(--space-5) var(--space-10);
  background-color: var(--brand-primary);
  border-radius: var(--border-radius-8);
  ${Typography.body_sm_medium}
  color: var(--text-white);
  cursor: pointer;
  text-decoration: none;
  &:hover {
    background-color: var(--brand-primary-hover);
  }
`;

const TaskIcons = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  height: 26px;
`;

const TaskDropdown = styled.div`
  display: flex;
  gap: var(--space-12);
  flex-direction: column;
`;

const TaskDrop = styled.div<Props>`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: var(--space-0);
  gap: var(--space-10);
  ${(props: Props) =>
    props.isTaskList &&
    css`
      padding-bottom: var(--space-12);
      border-bottom: 0.5px solid var(--border-primary);
    `}
`;

const Data = styled.div`
  width: 100%;
  ${FlexBetween}
  padding: var(--space-0);
  gap: var(--space-10);
  .dropdown-icon {
    transform: rotate(180deg);
  }
`;

const StarWithTitle = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  ${mobile_xl(css`
    display: none;
  `)}
`;

const SVGDiv = styled.div`
  ${AlignCenter}
  svg {
    fill: none;
  }
  .filters-icon-color {
    fill: var(--text-secondary);
    stroke: none;
  }
`;

const GroupDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
`;

const TaskFilterDiv = styled.div`
  display: flex;
  padding-inline: var(--space-6);
  flex-direction: column;
  gap: var(--space-12);
`;

const ProjectIconContainer = styled.div`
  ${FlexCenter}
  gap: var(--space-8);
`;

const DropDiv = styled.div`
  .more-icon {
    &:hover {
      background-color: var(--background-hover-navbar);
      ${mobile_xl(css`
        background-color: unset;
      `)}
    }
    ${mobile_xl(css`
      padding: var(--space-6);
    `)}
  }
  .active-state {
    background-color: var(--background-active-navbar);
    border-radius: var(--border-radius-8);
    .more-icon:hover {
      background-color: var(--background-active-navbar);
    }
  }
`;

const Properties = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
`;

const PropertiesHeading = styled.p`
  ${Typography.body_md}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const ChipSection = styled.div`
  ${AlignCenter}
  flex-wrap: wrap;
  gap: var(--space-6);

  .task-filter-chip-active:hover {
    background-color: var(--neutral-secondary);
  }
`;

const FileDropdown = styled.div`
  display: flex;
  gap: var(--space-12);
  flex-direction: column;
  margin-bottom: var(--space-2);
  .file-filters {
    path {
      fill: var(--text-primary);
    }
    stroke: none;
  }
`;

export {
  Container,
  Content,
  Title,
  ButtonBlock,
  Options,
  DropText,
  TextBlock,
  PrimaryButton,
  TaskIcons,
  Data,
  TaskDrop,
  TaskDropdown,
  MainContent,
  StarWithTitle,
  SVGDiv,
  GroupDiv,
  TaskFilterDiv,
  ProjectIconContainer,
  DropDiv,
  Properties,
  PropertiesHeading,
  ChipSection,
  FileDropdown
};
